import * as React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { Theme, StyleRulesCallback, withStyles, WithStyles } from '@material-ui/core/styles';
import { push } from "react-router-redux";
import { bindActionCreators } from 'redux';
import { RouteName } from '../routeNames';
import { localizations } from '../localization/localization';

const styles: StyleRulesCallback<Theme, object> = (theme: Theme) => ({
  loginContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  button: {
    fontFamily: 'Roboto',
    marginBottom: 8
  },
  link: {
    color: '#F7F8F9',
    fontSize: 14
  }
});

type LoginRegisterButtonsProps = WithStyles & { goToActions: typeof goActions };

class LoginRegisterButtons extends React.Component<LoginRegisterButtonsProps> {

    public render() {
        const { classes, goToActions } = this.props;

        return (
          <div className={classes.loginContainer}>
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={() => goToActions.goTo(RouteName.Login)}
            >
              {localizations.login.login}
            </Button>
            <a
              href="#"
              className={classes.link}
              onClick={() => goToActions.goTo(RouteName.ResetPassword)}
            >
               {localizations.register.didYouForgetPassword}
            </a>
          </div>
        );
    }
}

const goActions = {
    goTo: (location: string) => push(location)
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    goToActions: bindActionCreators(goActions, dispatch)
  }
}

export default withStyles(styles)(connect<any, { goToActions: any }, any>(null, mapDispatchToProps)(LoginRegisterButtons));


// WEBPACK FOOTER //
// ./src/common/LoginRegisterButtons.tsx